import { InstallerTasksPage } from './../installer-tasks/installer-tasks';
import { TasksProvider } from './../../providers/tasks/tasks';
import { User } from './../../providers/auth/models';
import { AuthProvider } from '../../providers/auth/auth';
import { UtilsProvider } from '../../providers/utils/utils';
import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController
} from 'ionic-angular';
import { TaskData } from '../../providers/tasks/models';

@IonicPage()
@Component({
  selector: 'page-task-complete',
  templateUrl: 'task-complete.html'
})
export class TaskCompletePage {
  public task;
  private taskData: TaskData;
  private syncing: boolean = false;
  private syncingStatus: any = {
    title: 'Syncronising',
    message: 'connecting',
    percent: 0
  };

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public tasksProvider: TasksProvider,
    public alertCtrl: AlertController,
    private utilsProvider: UtilsProvider,
    private authProvider: AuthProvider,
  ) {
    this.task = this.tasksProvider.getSelectedTask();
  }

  ionViewDidLoad() {
  }
  ionViewDidEnter() {
    this.syncTasks();
  }

  syncTasks() {
    this.task = this.tasksProvider.getSelectedTask(); // this.navParams.get('task');
    this.taskData = this.tasksProvider.getTaskData(this.task.id);

    const userData: User = this.authProvider.userData.data as User;
    const nonPCCompanies = userData.companies?.filter(company => !company.startsWith('snn:group:company:plumber-connect-'));
    const companyName = this.utilsProvider.groupSnnToName(nonPCCompanies[0]);

    const completeNote = "Completed by " + userData.firstName + " " + userData.lastName + " from " + companyName;

    this.tasksProvider.addNote(this.task, completeNote).subscribe(response => {
      if(response.notes.length > 0){
        this.continueSync()
      } else {
        this.continueSync()
      }
    })
  }
  continueSync() {

    this.syncing = true;
    this.tasksProvider.syncTask(this.taskData, this.task).subscribe(
      data => {
        this.syncingStatus = data;
      },
      error => {
        this.syncing = false;
        this.syncingStatus = error.error;
        this.displayError(error);
      },
      () => {
        this.navCtrl.setRoot(InstallerTasksPage, {
          animate: true,
          direction: 'forward'
        });
      }
    );
  }

  displayError(err) {
    const errorObj = err;
    const message =
      err && err.status === 0
        ? 'There was an error communicating with the server. Check your internet connection and try again.'
        : errorObj && errorObj.error.message
        ? errorObj.error.message
        : 'An unknown error occured. ';
    let alert = this.alertCtrl.create({
      title: 'Error',
      message: message,
      buttons: [
        {
          text: 'OK',
          role: 'ok',
          handler: data => {
            //this.afterError();
          }
        }
      ]
    });
    alert.present();
  }
}



// WEBPACK FOOTER //
// ./src/pages/task-complete/task-complete.ts